module.exports = __webpack_public_path__ + "static/media/briefcase.d58df13b.svg";